import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-itams.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { ViewApplicationLocationItamsConstants } from "./view-application-location-itams.constants";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { MapService } from "../../../../../map/shared/map.service";
import { InformalTradeService } from "../../../../../shared/services/modules/informal-trade.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { debounceTime } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
let ViewApplicationLocationItamsComponent = class ViewApplicationLocationItamsComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    appController;
    routerParamsService;
    changeDetectorRefs;
    mapService;
    informalTradeService;
    requestStatusService;
    viewApplicationService;
    active;
    baysForm;
    descriptionLabel1 = ViewApplicationLocationItamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationItamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationItamsConstants.DESCRIPTION_LABEL_3;
    validationMessages = ViewApplicationLocationItamsConstants.VALIDATION_MESSAGES;
    addressControl = ViewApplicationLocationItamsConstants.ADDRESS_CONTROL;
    bayNumberControl = ViewApplicationLocationItamsConstants.BAY_NUMBER_CONTROL;
    baySizeControl = ViewApplicationLocationItamsConstants.BAY_SIZE_CONTROL;
    addressTextPlaceHolder = ViewApplicationLocationItamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    bayNumberPlaceHolder = ViewApplicationLocationItamsConstants.BAY_NUMBER_PLACEHOLDER;
    baySizeTextPlaceHolder = ViewApplicationLocationItamsConstants.BAY_SIZE_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeBayLabel = ViewApplicationLocationItamsConstants.REMOVE_BAY_LABEL;
    saveBtnPlaceholder = ViewApplicationLocationItamsConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    isMapLoaded = false;
    mapComponent;
    getApplicationSetBaysObservableSubscription;
    selectedBaySubjectSubscription;
    getStepMetaObservableSubscription;
    getTrueCentroidSubscription;
    constructor(aflaModuleStrategyService, route, appController, routerParamsService, changeDetectorRefs, mapService, informalTradeService, requestStatusService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.informalTradeService = informalTradeService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToBay();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionBayEnabled = true;
    }
    ngOnDestroy() {
        this.mapService.actionBayEnabled = false;
    }
    handleRouteChange() {
        this.initialiseMetadata();
    }
    onBtnSaveClicked() {
        if (this.baysForm.valid) {
            const points = [];
            const bays = [];
            const baysArray = this.getBays();
            for (const bayControl of baysArray.controls) {
                const centroid = bayControl.get("centroid").value;
                points.push(`(${centroid.x} ${centroid.y})`);
                const geometry = bayControl.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                let bay = null;
                if (bayControl.get("bay") !== null && bayControl.get("bay").value !== null) {
                    bay = bayControl.get("bay").value;
                    bay.address = bayControl.get("address").value;
                    bay.bayNumber = bayControl.get("bayNumber").value;
                    bay.baySize = bayControl.get("baySize").value;
                }
                else {
                    bay = {
                        address: bayControl.get("address").value,
                        bayNumber: bayControl.get("bayNumber").value,
                        baySize: bayControl.get("baySize").value,
                        shape: geometryJSON,
                        updateGeometry: false,
                        wkid: 102100
                    };
                }
                bays.push(bay);
            }
            const params = {
                bays,
                applicationShape: `MULTIPOINT (${points.join(", ")})`,
                applicationWkid: 102100
            };
            this.getApplicationSetBaysObservableSubscription =
                this.informalTradeService.getApplicationSetBaysObservable(this.application.id, params)
                    .subscribe({
                    next: () => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationItamsConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getBays() {
        return this.baysForm.get("bays");
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    onBtnRemoveBayClicked(bayIndex) {
        this.getBays().removeAt(bayIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        this.baysForm = this.aflaModuleStrategyService.form.get("baysForm");
        this.active = 0;
    }
    initialiseMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe(() => {
            this.loadMetadata();
        });
    }
    loadMetadata() {
        this.getApplicantData();
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `bays`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params)
            .pipe(takeUntil(this._destroy$), take(1)).subscribe((returnValue) => {
            const bayControl = this.getBays();
            bayControl.clear();
            this.application = returnValue.value[0];
            this.application.bays.forEach(bay => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(bay.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newBay = new FormGroup({
                    objectId: new FormControl(bay.id),
                    bay: new FormControl(bay),
                    address: new FormControl(bay.address, [Validators.required]),
                    bayNumber: new FormControl(bay.bayNumber, [Validators.required]),
                    baySize: new FormControl(bay.baySize, [Validators.required]),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    zones: new FormArray([], [Validators.min(1)])
                });
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.getTrueCentroidSubscription = this.viewApplicationService.getTrueCentroid(url, formData)
                    .subscribe({
                    next: (response) => {
                        newBay.get("centroid").setValue(response.results[0].value);
                        bayControl.push(newBay);
                        this.active = bayControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        if (this.isMapLoaded) {
                            this.syncMapGeometries();
                        }
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationItamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    propertyDataAlternateColumnName(bayObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(bayObject)) {
            if (key === name1) {
                returnVal = bayObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = bayObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = bayObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getBays().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Town planning graphics", true);
        }
    }
    subscribeToBay() {
        this.selectedBaySubjectSubscription = this.mapService.$selectedBaySubject.pipe(debounceTime(1000)).subscribe(bay => {
            if (bay !== null) {
                this.requestStatusService.showBusySpinner("getBayData");
                const objectId = this.propertyDataAlternateColumnName(bay.attributes, "OBJECTID", "objectid");
                let found = false;
                this.getBays().controls.forEach(item => {
                    const check = item.get("objectId").value;
                    if (check === objectId) {
                        found = true;
                        this.appController.showMessage(ViewApplicationLocationItamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                        this.requestStatusService.removeBusySpinner("getBayData");
                    }
                });
                if (!found) {
                    const newBay = new FormGroup({
                        objectId: new FormControl(this.propertyDataAlternateColumnName(bay.attributes, "OBJECTID", "objectid")),
                        address: new FormControl(this.propertyDataAlternateColumnName(bay.attributes, "Address", "address"), [Validators.required]),
                        bayNumber: new FormControl(this.propertyDataAlternateColumnName(bay.attributes, "BayNumber", "baynumber"), [Validators.required]),
                        baySize: new FormControl(this.propertyDataAlternateColumnName(bay, "Size", "size"), [Validators.required]),
                        geometry: new FormControl(bay.geometry),
                        centroid: new FormControl(null, [Validators.required])
                    });
                    const proxyUrl = ApiProxyConstants.URL;
                    const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                        + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                    const url = `${proxyUrl}?${gpToolUrl}`;
                    const formData = new FormData();
                    formData.append("f", "json");
                    formData.append("geometryJSON", JSON.stringify(bay.geometry));
                    this.viewApplicationService.getTrueCentroid(url, formData)
                        .subscribe({
                        next: (trueCentroidResponse) => {
                            newBay.get("centroid").setValue(trueCentroidResponse.results[0].value);
                            this.setBayTrueCentroidData(newBay, trueCentroidResponse);
                            this.syncMapGeometries();
                            this.requestStatusService.removeBusySpinner("getBayData");
                        },
                        error: (error) => {
                            this.requestStatusService.removeBusySpinner("getBayData");
                            this.appController.handleServerErrorMessage(ViewApplicationLocationItamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                        }
                    });
                }
            }
        });
    }
    setBayTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const bayControl = this.getBays();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        bayControl.push(newFormGroup);
        this.active = bayControl.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: InformalTradeService },
        { type: RequestStatusService },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationItamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-view-application-location-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationItamsComponent);
export { ViewApplicationLocationItamsComponent };
